import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import {Button} from "reactstrap";
import classNames from "classnames";
import moment from "moment";
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

const breadcrumbsStatic = [{
	name: 'Scores',
	url: '/scores',
	icon: 'users',
}];

class Scores extends Framework.Components.View {
	constructor(props) {
		super(props, 'line');
		this.state.data = [];
		this.state.filterDate = moment('2023-02-14').format();
		this.state.start_date = null;
		this.state.end_date = null;
		this.getTimeout = null;
		this.state.filteredUser = null;
	}

	getDispatch = async () => {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.filter = {
			'role': 3,
			'day': this.state.filterDate,
			'active': 'active',
			'selectedUsers': []
		}
		this.state.filter = model.filter;
		model.search = this.state.search
		this.data = await model.submit(null, this.read);
		let total = this.data.total;
		this.data = this.data.items;
		this.setState({data: this.data, total: total ?? null});
	}

	navigateDay = async (date, amount) => {
		this.setState({filterDate: moment(date).add(amount, 'day')}, async () => {
			this.state.start_date = null;
			this.state.end_date = null;
			if (this.getTimeout) {
				clearTimeout(this.getTimeout)
			}
			this.getTimeout = setTimeout(async () => {
				await this.getDispatch();
			}, 500)
		})
	}

	render() {
		let {history, roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: 'Live Scores',
				url: `/scores`,
				icon: 'users',
			}
		]);

		return (
			<div className={'container-fluid'}>

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Table View" value="table"/>
					<Tab label="Daily Chart View" value="chart"/>
					<Tab label="Hourly Chart View" value="line"/>
			{/*		<Tab label="Phone Logs Notes" value="phonelogsnotes-5"/>
					<Tab label="Calendar Notes" value="calendarnotes-6"/>
					<Tab label="Time Between Events" value="tbe-7"/>*/}
				</Tabs>

				<div className={'table-bar'}>
					<div className={"row rbc-toolbar"}>
						<div>
							<IconButton onClick={async () => {
								await this.navigateDay(this.state.filterDate, -1)
							}}><LeftArrowIcon/></IconButton>
							<button className="rbc-today" type="button" onClick={async () => {
								await this.navigateDay(Date.now(), 0)
							}}>Today
							</button>
							<IconButton onClick={async () => {
								await this.navigateDay(this.state.filterDate, 1)
							}}><RightArrowIcon/></IconButton>
						</div>
						<div className={"rbc-toolbar-label"}>
							<label onClick={() => {
								this.handleToggleModal('showDate')
							}}>
								{this.state.start_date && this.state.end_date ? (moment(this.state.start_date).format('dddd MMM D') + ' - ' + moment(this.state.end_date).format('dddd MMM D')) : moment(this.state.filterDate).format('dddd MMM D')}
							</label>
						</div>
					</div>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'table'})}>
					<Collections.Scores
						//id={3}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
						data={this.state.data ?? []}
						navToChart={(userId) => {this.setState({filteredUser: userId, tab: 'line'})}}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'chart'})}>
					<Collections.ScoresChart
						//id={4}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
						date={this.state.filterDate}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'line'})}>
					<Collections.ScoresChartLine
						//id={4}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
						data={this.state.lineData ?? null}
						date={this.state.filterDate}
						setStartDate={(date) => this.setState({start_date: date})}
						setEndDate={(date) => this.setState({end_date: date})}
						filteredUser={this.state.filteredUser ?? null}
					/>
				</div>

				{/*<div className={classNames({'hidden': this.state.tab !== 'phonelogsnotes-5'})}>
					<Collections.Scores
						id={5}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'calendarnotes-6'})}>
					<Collections.Scores
						id={6}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'tbe-7'})}>
					<Collections.Scores
						id={7}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>*/}
			</div>

		)
	}
}

export default Framework.Components.withRootState(Scores);